import { Form } from 'antd';
import { CargoType } from 'types/cargo';
import { CargoItemForm } from 'components/common/cargo-item-form';
import { ContainerCargoItemInputFields } from 'components/common/container-cargo-item-input-fields';
import type { ICargoItemCreateFormProps } from './types';

export const CargoItemCreateForm: React.FC<ICargoItemCreateFormProps> = (props) => {
  const { form, formId, onFinish, cargoType } = props;

  if (cargoType === CargoType.CONTAINER) {
    return (
      <Form form={form} id={formId} layout='vertical' onFinish={onFinish}>
        <ContainerCargoItemInputFields form={form} name='specificCargoItem' />
      </Form>
    );
  }

  return <CargoItemForm form={form} formId={formId} name='cargoItems' onFinish={onFinish} />;
};
